import { MapPin } from "lucide-react";
import { Reveal, Overline } from "@/components/Motion";
import { ASSETS } from "@/lib/assets";

const MARKERS = [
  { label: "Italy", left: "50%", top: "30%" },
  { label: "Dubai, UAE", left: "60%", top: "43%" },
];

const CARDS = [
  { title: "Dubai, UAE", sub: "Regional office & operations" },
  { title: "Italy", sub: "Headquarters & design studio" },
  { title: "Global Delivery Network", sub: "Projects delivered worldwide" },
];

export const LocationsMap = () => (
  <section data-testid="locations-section" className="px-6 md:px-12 lg:px-20 py-24 md:py-32">
    <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 mb-12">
      <div className="lg:col-span-4">
        <Reveal><Overline className="block mb-4">Global Presence</Overline></Reveal>
      </div>
      <div className="lg:col-span-8">
        <Reveal delay={0.1}>
          <h2 className="font-serif font-light text-4xl md:text-5xl text-evo-pearl">Where EVO operates</h2>
        </Reveal>
      </div>
    </div>

    {/* Single elegant map */}
    <Reveal>
      <div className="relative w-full aspect-[21/9] md:aspect-[21/8] overflow-hidden border border-white/10">
        <img src={ASSETS.worldMap} alt="EVO global presence map" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-evo-black/45" />
        <div className="absolute inset-0" style={{ background: "radial-gradient(ellipse at center, rgba(5,5,5,0) 40%, rgba(5,5,5,0.5) 100%)" }} />
        {MARKERS.map((m) => (
          <div key={m.label} className="absolute -translate-x-1/2 -translate-y-1/2 group" style={{ left: m.left, top: m.top }}>
            <span className="absolute left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 w-3.5 h-3.5 rounded-full bg-evo-gold/60 evo-marker-ring" />
            <span className="relative block w-3.5 h-3.5 rounded-full bg-evo-gold shadow-[0_0_14px_5px_rgba(200,169,126,0.55)]" />
            <span className="absolute left-6 top-1/2 -translate-y-1/2 whitespace-nowrap text-[10px] uppercase tracking-[0.2em] text-evo-pearl bg-evo-black/80 border border-evo-gold/20 px-3 py-1.5 opacity-0 group-hover:opacity-100 transition-opacity duration-300">
              {m.label}
            </span>
          </div>
        ))}
      </div>
    </Reveal>

    {/* Premium location cards */}
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6 mt-8">
      {CARDS.map((c, i) => (
        <Reveal key={c.title} delay={i * 0.08}>
          <div data-testid={`location-card-${i}`} className="group h-full bg-evo-marble1 border border-white/8 hover:border-evo-gold/30 transition-colors duration-500 p-8">
            <MapPin size={20} className="text-evo-gold mb-8" />
            <h3 className="font-serif text-2xl text-evo-pearl mb-2 group-hover:text-evo-gold transition-colors duration-300">{c.title}</h3>
            <p className="text-evo-ash text-sm font-light">{c.sub}</p>
          </div>
        </Reveal>
      ))}
    </div>
  </section>
);
